import { get } from 'lodash';
import React, { useContext, useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router';

import StarsInfo from '@swf/components/StarsInfo/StarsInfo';
import { ModalContext } from '@swf/components/StarsModal/Context';
import Body from '@swf/components/StarsModal/components/Body';
import Translation from '@swf/components/Translation/Translation';
import { useHomeGamesWidget } from '@swf/poker';

import Header from '../../../../Modal/Header/Header';
import ShareClub from '../../../../ShareClub/ShareClub';
import SuccessIcon from '../../assets/success.svg';

import {
  TXTCLI_CONGRATULATIONSX,
  TXTCLI_Club_ID,
  TXTCLI_Invitation_Code,
  TXTWCL_Copy_Instructions,
  TXTWCL_Please_send_the_instructions_t_ELL,
  TXTWCL_XspanXN0X_spanX_has_been_succe_ELL,
  TXTWCL_Your_Club_Name_is_being_review_ELL
} from './CreateClubSuccess.messages.json';
import styles from './CreateClubSuccess.scss';

interface LocationState {
  clubId: number;
  clubName: string;
  invitationCode: string;
  widgetId?: string;
}

export const CreateClubSuccess: React.FC = () => {
  const { state } = useLocation<LocationState>();
  const { setStyle } = useContext(ModalContext);
  const { widgetDispatch } = useHomeGamesWidget(state.widgetId);

  const clubId = get(state, 'clubId');
  const clubName = get(state, 'clubName');
  const invitationCode = get(state, 'invitationCode');

  useLayoutEffect(() => {
    setStyle({
      className: styles.createClubSuccessModal,
      closeOnOverlayClick: true,
      closeOnEsc: true
    });
  });

  useEffect(
    () => () => {
      widgetDispatch.getUserClubs();
    },
    [state, widgetDispatch]
  );

  return (
    <>
      <Header title={<Translation {...TXTCLI_CONGRATULATIONSX} />} />
      <Body className={styles.body}>
        <div className={styles.container} data-testid="create-club-success-modal">
          <StarsInfo type="confirmation" className={styles.successPanel}>
            <div className={styles.icon}>
              <SuccessIcon />
            </div>
            <div>
              <Translation
                {...TXTWCL_XspanXN0X_spanX_has_been_succe_ELL}
                values={{ 0: clubName }}
              />
            </div>
          </StarsInfo>
          <div className={styles.divider} />
          <div className={styles.clubDetails}>
            <Translation {...TXTCLI_Club_ID} />:<span>{clubId}</span>
          </div>
          <div className={styles.divider} />
          <div className={styles.clubDetails}>
            <Translation {...TXTCLI_Invitation_Code} />:<span>{invitationCode}</span>
          </div>
          <div className={styles.divider} />
          <p className={styles.reviewText}>
            <Translation {...TXTWCL_Your_Club_Name_is_being_review_ELL} values={{ 0: 5 }} />
          </p>
          <p className={styles.sendInstructionsText}>
            <Translation {...TXTWCL_Please_send_the_instructions_t_ELL} />
          </p>
          <ShareClub
            clubId={Number(clubId)}
            invitationCode={invitationCode || ''}
            buttonProps={{
              id: 'copyInstructions',
              translation: TXTWCL_Copy_Instructions,
              type: 'submit'
            }}
          />
        </div>
      </Body>
    </>
  );
};

export default CreateClubSuccess;
